<template>
  <div v-if="confirmDialog.visible" class="confirm-dialog p-dialog surface-card p-4 border-round shadow-4" style="max-width: 450px; z-index: 1100;">
    <div class="confirm-dialog-content text-center">
      <h3 class="m-0 text-xl font-bold text-900 mb-2">Conferma Richiesta Prova</h3>
      
      <div v-if="confirmDialog.targetApprovato === 1" class="mb-3">
        <p class="text-600 m-0 mb-3">
          Stai per <b>accettare (OK)</b> la richiesta prova. Seleziona il corso da associare:
        </p>
        <Dropdown
          v-model="confirmDialog.selectedCorso"
          :options="corsi"
          optionLabel="nome"
          placeholder="Seleziona un corso"
          class="w-full text-left"
        />
      </div>

      <div v-else class="mb-3">
        <p class="text-600 m-0 mb-3">
          Stai per <b class="text-red-600">rifiutare / annullare (KO)</b> questa richiesta prova.
        </p>
      </div>

      <div class="flex justify-content-center gap-3 mt-3">
        <Button 
          @click="confirmDialogAccept" 
          :label="confirmDialog.targetApprovato === 1 ? 'Conferma OK' : 'Conferma KO'" 
          :class="confirmDialog.targetApprovato === 1 ? 'p-button-success' : 'p-button-danger'" 
        />
        <Button @click="confirmDialogReject" label="Annulla" class="p-button-secondary p-button-outlined" />
      </div>
    </div>
  </div>

  <Loader v-if="loading" />
  
  <Card>
    <template v-slot:title>
      <h3 class="m-0">Richieste Prova Utenti</h3>
    </template>
    <template v-slot:content>
      <div class="col-12 mb-3">
        <Button @click="addBox" class="p-button-info" :label="(boxes.length==0)?'Nuova':'Chiudi'"/>
        <div v-for="(box, index) in boxes" :key="index" class="box p-5 border-round surface-100 mt-3"><br/>
          <div class="flex flex-column md:flex-row gap-3">
            <div class="col-12 md:col-6">
              <Dropdown id="id_atleta" v-model="box.atleta" :options="atleti" :filter="true" placeholder="Seleziona un atleta" :class="['inputfield w-full',{'p-invalid': validationErrors.corso && submitted}]" :virtualScrollerOptions="{ itemSize: 38 }" @change="onChangeInput($event, 'atleta')">
                <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ slotProps.value.nome }} {{ slotProps.value.cognome }}</div>
                  </div>
                  <span v-else>
                    {{ slotProps.placeholder }}
                  </span>
                </template>
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ slotProps.option.nome }} {{ slotProps.option.cognome }} {{ slotProps.option.nota }}</div>
                  </div>
                </template>
              </Dropdown>  
            </div>

            <div class="col-12 md:col-6">
              <Dropdown id="id_corso" v-model="box.tipocorso" :options="tipocorsi" :filter="true" placeholder="Seleziona corso" :class="['inputfield w-full',{'p-invalid': validationErrors.corso && submitted}]" :virtualScrollerOptions="{ itemSize: 38 }" @change="onChangeInput($event, 'corso')">
                <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ slotProps.value.nome }}</div>
                  </div>
                  <span v-else>
                    {{ slotProps.placeholder }}
                  </span>
                </template>
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ slotProps.option.nome }} {{ slotProps.option.nota }}</div>
                  </div>
                </template>
              </Dropdown>  
            </div>
          </div>
          <div class="mt-3">
            <Button class="p-button-success" icon="pi pi-check" @click="saveBox(index)" label="Salva"/>
          </div>
        </div>
      </div>

      <!-- Richieste da Gestire -->
      <div class="col-12 flex flex-column md:col-12">
        <h4 class="text-xl font-bold mb-3">Richieste da gestire ({{ pendingRequests.length }})</h4>
        
        <div v-if="pendingRequests.length === 0" class="p-4 text-center text-600 font-medium surface-50 border-round">
          <i class="pi pi-check-circle text-green-500 text-3xl mb-2 block"></i>
          Nessuna richiesta prova in attesa da gestire.
        </div>

        <DataTable v-else :value="pendingRequests" tableStyle="min-width: 50rem" class="p-datatable-sm p-datatable-striped">
          <Column field="creation_time" header="Data creazione">
            <template #body="slotProps">
              {{ moment(slotProps.data.creation_time).format('DD/MM/Y') }}
            </template>
          </Column>
          <Column field="sorgente" header="Sorgente"></Column>
          <Column field="atleta" header="Atleta">
            <template #body="{data}">
              <Button @click="goToAtleta(data.id_atleta)" class="p-button-link p-0 font-bold text-blue-700">{{ data.atleta }}</Button>
            </template>
          </Column>
          <Column field="datadinascita" header="Data di Nascita"></Column>
          <Column field="tipocorso" header="Tipologia Corso"></Column>
          <Column field="corso" header="Corso"></Column>
          
          <!-- Esito Validazione (OK / KO) -->
          <Column header="Esito Validazione" style="min-width: 170px" headerClass="text-center" bodyClass="text-center">
            <template #body="slotProps">
              <div class="flex justify-content-center gap-2">
                <Button 
                  label="OK" 
                  icon="pi pi-check" 
                  class="p-button-success p-button-sm px-3" 
                  @click="openConfirmDialog(slotProps.data.id, 1, slotProps.data.corso)" 
                  v-tooltip.top="'Accetta richiesta ed assegna corso (OK)'"
                />
                <Button 
                  label="KO" 
                  icon="pi pi-times" 
                  class="p-button-danger p-button-sm px-3" 
                  @click="openConfirmDialog(slotProps.data.id, -1, slotProps.data.corso)" 
                  v-tooltip.top="'Rifiuta / Annulla richiesta prova (KO)'"
                />
              </div>
            </template>
          </Column>

          <Column field="data_approvazione" header="Data approvazione"></Column>
        </DataTable>
      </div>

      <!-- Richieste già gestite -->
      <div class="col-12 mt-4">
        <Panel header="Richieste già gestite" :toggleable="true" :collapsed="true">
          <DataTable :value="managedRequests" tableStyle="min-width: 50rem" class="p-datatable-sm p-datatable-striped">
            <Column field="creation_time" header="Data creazione">
              <template #body="slotProps">
                {{ moment(slotProps.data.creation_time).format('DD/MM/Y') }}
              </template>
            </Column>
            <Column field="sorgente" header="Sorgente"></Column>
            <Column field="atleta" header="Atleta">
              <template #body="{data}">
                <Button @click="goToAtleta(data.id_atleta)" class="p-button-link p-0 font-bold text-blue-700">{{ data.atleta }}</Button>
              </template>
            </Column>
            <Column field="datadinascita" header="Data di Nascita"></Column>
            <Column field="tipocorso" header="Tipologia Corso"></Column>
            <Column field="corso" header="Corso"></Column>
            
            <Column header="Stato / Esito" field="approvato" headerClass="text-center" bodyClass="text-center">
              <template #body="slotProps">
                <Tag 
                  v-if="slotProps.data.approvato == 1" 
                  severity="success" 
                  value="OK (Accettato)" 
                />
                <Tag 
                  v-else-if="slotProps.data.approvato == -1 || slotProps.data.approvato < 0" 
                  severity="danger" 
                  value="KO (Rifiutato)" 
                />
                <Tag 
                  v-else 
                  severity="warning" 
                  value="In attesa" 
                />
              </template>
            </Column>

            <Column field="data_approvazione" header="Data approvazione"></Column>
          </DataTable>
        </Panel>
      </div>
    </template>
  </Card>
</template>

<script>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Loader from "@/components/Loader.vue";
import Service from '@/services/levante-api/levante-api';
import { useToast } from 'primevue/usetoast';
import moment from 'moment';

export default {
  name: 'AppRichiestaProva',
  components: {
    Loader,
  },
  setup() {
    const loading = ref(true);
    const richiesteProva = ref([]);
    const self = getCurrentInstance();
    const toast = useToast();
    const corsi = ref([]);
    const tipocorsi = ref([]);
    const atleti = ref([]);
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const boxes = ref([]);
    const lifeTime = 3000;

    const pendingRequests = computed(() => richiesteProva.value.filter(r => r.approvato == 0));
    const managedRequests = computed(() => richiesteProva.value.filter(r => r.approvato != 0));

    const validationErrors = ref({});
    const confirmDialog = ref({
      visible: false,
      id: null,
      targetApprovato: 1,
      selectedCorso: null
    });

    const goToAtleta = (idatleta) => {
      window.open(`/atleta/${idatleta}/dettagli`);
    };

    const openConfirmDialog = (id, targetApprovato, selectedCorsoName) => {
      confirmDialog.value.visible = true;
      confirmDialog.value.id = id;
      confirmDialog.value.targetApprovato = targetApprovato;
      confirmDialog.value.selectedCorso = corsi.value.find(corso => corso.nome === selectedCorsoName) || null;
    };
    
    const confirmDialogAccept = () => {
      toggleApprove(confirmDialog.value.id, confirmDialog.value.targetApprovato, confirmDialog.value.selectedCorso);
      confirmDialog.value.visible = false;
    };

    const confirmDialogReject = () => {
      confirmDialog.value.visible = false;
    };

    const toggleApprove = async (id, targetApprovato, selectedCorso) => {
      loading.value = true;

      try {
        let fd = new FormData();  
        fd.append('approvato', targetApprovato);

        if (targetApprovato === 1) {
          if (!selectedCorso) {
            toast.add({ severity: 'error', summary: 'Errore', detail: 'Devi selezionare un corso', life: lifeTime });
            loading.value = false;
            return;
          }
          fd.append('id_corso', selectedCorso.id);
        }

        await service.updateApprovaRichiesta(id, fd);  
        
        const labelText = targetApprovato === 1 ? 'OK (Accettato)' : 'KO (Rifiutato / Annullato)';
        const severity = targetApprovato === 1 ? 'success' : 'warn';

        toast.add({ 
          severity: severity, 
          summary: 'Successo', 
          detail: `Richiesta prova registrata come ${labelText}`, 
          life: lifeTime 
        });

        initData();
      } catch (error) {
        toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: 'Errore durante l\'aggiornamento della richiesta', 
          life: lifeTime 
        });
      } finally {
        loading.value = false;
      }
    };

    const onChangeInput = (evt, prop) => {
      let value;
      switch (prop) {
        case 'corso':
        case 'atleta':
          value = evt.value;
          getAtleti();
          getCorsiAttivi();
          break;
        default:
          value = evt.target.value;
          break;
      }
      if (value == '' || value == null) {
        validationErrors.value[prop] = true;
      } else {
        delete validationErrors.value[prop];
      }
    };

    const getTipoCorso = async () => {
      await service.getTypeCorso().then((res) => {
        tipocorsi.value = res.items || [];
      });
    };

    const getCorsiAttivi = async () => {
      await service.getCorsiAttivi().then((res) => {
        corsi.value = res.items || [];
      });
    };

    const getAtleti = async () => {
      await service.getAtleti().then((res) => {
        atleti.value = res.items || [];
      });
    };

    const initData = () => {
      service.getRichiesteProva().then((res) => {
        richiesteProva.value = res.items || [];
        loading.value = false;
      });

      corsi.value = [];
      getCorsiAttivi();
      atleti.value = [];
      getAtleti();
      tipocorsi.value = [];
      getTipoCorso();
    };
 
    const addBox = () => {
      if (boxes.value.length == 0) {
        boxes.value.push({
          title: '',
          corso: null,
          tipocorso: null,
          image: null,
          atleta: null
        });
      } else {
        boxes.value.pop();
      }
    };

    const validateForm = () => {
      return true;
    };

    const saveBox = async (index) => {
      if (validateForm()) {
        loading.value = true;
        const box = boxes.value[index];
        let fd = new FormData();  
        fd.append('tipocorso', box.tipocorso.id);
        fd.append('atleta', box.atleta.id);
        
        service.sendRichiestaProva(fd)
          .then((res) => {
            let severity = res.item.esito;
            let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo';
            let detail = res.item.messaggio;
            initData();
            if (res.item.esito == 'success') {
              boxes.value.pop();
            }
            toast.add({ severity: severity, summary: summary, detail: detail, life: lifeTime });
          })
          .finally(() => {
            loading.value = false;
          });
      } else {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: `Ci sono dei dati mancanti`, life: lifeTime });
      }
    };
   
    onMounted(() => { 
      loading.value = true;
      const promises = [initData()];
      
      Promise.all(promises).finally(() => {
        loading.value = false;
      });
    });

    return {
      loading,
      richiesteProva,
      addBox,
      saveBox,
      boxes,
      corsi,
      atleti,
      validationErrors,
      onChangeInput,
      moment,
      confirmDialog,
      openConfirmDialog,
      confirmDialogAccept,
      confirmDialogReject,
      tipocorsi,
      goToAtleta,
      pendingRequests,
      managedRequests
    };
  },
}
</script>

<style scoped>
.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.25);
  z-index: 1100;
  border-radius: 8px;
}
</style>
